import React from 'react';
import moment from 'moment';
import { toArray } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    EBON_ACTIVATION_TYPE_ONLINE,
    EBON_ACTIVATION_TYPE_OFFLINE,
    EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE
} from '../../../constants/ebon';
import { PATH } from '../../../constants/path';
import { MOMENTJS_DATE_FORMAT } from '../../../constants/moment';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';
import { ENTERPRISE_CARD_PARTNER_EBC_ID } from '../../../constants/ebon';

import { showModal } from '../../../services/modal/actions';

import { getPartner, getEbonPartner } from '../../../services/partner/selector';

import {
    getInstertitielCashbackUrl,
    displayableCashback,
    hasCashback,
    hasCashbackOffline,
    hasEbon
} from '../../../services/partner/utils';

import ButtonComponent from '../../button/ButtonComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import PartnerBlockHorizontalComponent from '../../partner/PartnerBlockHorizontalComponent';

const DELAI_VALIDATION_DEFAULT = 15;

class HeaderComponent extends React.Component {
    showLoginModal = () => {
        const { isAuthenticated, showModal } = this.props;

        if (!isAuthenticated) {
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    renderSeoLine = () => {
        const { isEbon, ebonSeo, ebonPartner } = this.props;

        if (isEbon && ebonSeo && ebonPartner && ebonSeo.partnerId === ebonPartner.id) {
            return <p className="seoLine1">{ebonSeo.h1FirstRow}</p>;
        }
    };

    renderCashback = () => {
        const { i18nPartner, partner, isOffline, discounts, isEbon, ebonPartner } = this.props;
        if (
            (partner &&
                ((!isOffline && hasCashback(partner)) ||
                    (isOffline && hasCashbackOffline(partner)))) ||
            (isEbon && hasEbon(ebonPartner))
        ) {
            const { percent, fixed, initialPercent, initialFixed, label } = isOffline
                ? partner.mostDisplayableDiscountOffline
                : isEbon && ebonPartner && ebonPartner.ebonDiscount
                ? {
                      fixed: ebonPartner.ebonDiscount.cashback.fixed.value,
                      percent: ebonPartner.ebonDiscount.cashback.percent.value,
                      initialPercent: ebonPartner.ebonDiscount.cashback.percent.initialValue
                  }
                : partner.mostDisplayableDiscountOnline;
            const initialCashback = displayableCashback(initialPercent, initialFixed);
            const isMultiDiscount =
                discounts &&
                !isEbon &&
                discounts.filter(d => (isOffline ? d.offlineActive : d.onlineActive)).length > 1;

            return (
                <div className="cashback">
                    <span className="upTo">{isMultiDiscount && `${i18nPartner.jusqua} `}</span>
                    <span>
                        <span className="value">
                            {displayableCashback(percent, fixed)} {i18nPartner.rembourse}
                            {(percent > 1 || fixed > 1) && 's'}
                        </span>
                    </span>{' '}
                    {label || (
                        <span>
                            {isEbon
                                ? i18nPartner.EBON_DISCOUNT_LABEL
                                : i18nPartner.DEFAULT_DISCOUNT_LABEL}

                            {initialCashback && (
                                <span className="olieu grey">
                                    &nbsp;
                                    {i18nPartner.aulieude} {initialCashback}
                                </span>
                            )}
                        </span>
                    )}
                </div>
            );
        } else {
            return <div className="cashback">{i18nPartner.pasdecashbackencemoment}</div>;
        }
    };

    // render the estimated date validation block
    renderEstimatedValidationDate = () => {
        const { partner, i18nPage, isEbon, isOffline } = this.props;

        if (isEbon || isOffline) return null;

        const validationDelay = partner ? partner.validationDelay : DELAI_VALIDATION_DEFAULT;
        const isValidationAfterServiceConsumption =
            partner && partner.validationAfterServiceConsumption;
        const estimatedValidationDate = moment()
            .add(validationDelay, 'days')
            .format(MOMENTJS_DATE_FORMAT);

        return partner && partner.validationDelay > -1 && hasCashback(partner) ? (
            <div className="validation-date">
                {`${i18nPage.ESTIMATED_VALIDATION_DATE} `}
                <br className="show-mobonly" />
                <span>
                    {isValidationAfterServiceConsumption
                        ? i18nPage.VALIDATION_AFTER_SERVICE_CONSUMPTION
                        : estimatedValidationDate}
                </span>
            </div>
        ) : null;
    };

    renderEbonAvailability = () => {
        const { i18nPage, isEbon, ebonPartner } = this.props;

        if (
            isEbon &&
            ebonPartner &&
            ebonPartner.ebonDiscount &&
            ebonPartner.ebcId !== ENTERPRISE_CARD_PARTNER_EBC_ID
        ) {
            const discount = ebonPartner.ebonDiscount;
            if (discount.activationType === EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE) {
                return <p className="availabilityType">{i18nPage.EBON_TYPE_ON_OFF}</p>;
            } else if (discount.activationType === EBON_ACTIVATION_TYPE_ONLINE) {
                return <p className="availabilityType">{i18nPage.EBON_TYPE_ON}</p>;
            } else if (discount.activationType === EBON_ACTIVATION_TYPE_OFFLINE) {
                return <p className="availabilityType">{i18nPage.EBON_TYPE_OFF}</p>;
            }
        }
        return null;
    };

    renderEnterpriseCardCumulative = () => {
        const { i18nPage, isEbon, ebonPartner } = this.props;

        if (isEbon && ebonPartner && ebonPartner.ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID) {
            return <p className="enterprisecardCumul">{i18nPage.ENTERPRISE_CARD_CUMULATIVE}</p>;
        }
    };

    renderCTAButton = () => {
        const { isAuthenticated, isOffline, isEbon, partner, i18nPage } = this.props;
        const url = getInstertitielCashbackUrl(partner);

        if (!isAuthenticated) {
            return (
                <ButtonComponent
                    color="fifth"
                    text={isOffline ? i18nPage.SEND_TICKET : i18nPage.TAKETHEOFFER}
                    type="button"
                    onClick={this.showLoginModal}
                />
            );
        }
        if (!isEbon && !isOffline && partner) {
            if (isAuthenticated) {
                return (
                    <LinkButtonComponent
                        color="fifth"
                        text={i18nPage.TAKETHEOFFER}
                        title={i18nPage.TAKETHEOFFER}
                        to={url}
                        name="merchantCard-toPartner"
                        target="_blank"
                        onClick={() => this.showLoginModal()}
                    />
                );
            }
        }
        if (isOffline && partner) {
            if (isAuthenticated) {
                return (
                    <LinkButtonComponent
                        color="fifth"
                        text={i18nPage.SEND_TICKET}
                        title={i18nPage.SEND_TICKET}
                        name="merchantCard-toFlashingTicket"
                        to={`${PATH.FLASHING_TICKET_PAGE}?id=${partner.id}`}
                        onClick={() => this.showLoginModal()}
                    />
                );
            }
        }

        return null;
    };

    render() {
        const { partner, isEbon, ebonPartner } = this.props;
        const currentPartner = isEbon ? ebonPartner : partner;

        return (
            <PartnerBlockHorizontalComponent
                partner={currentPartner}
                noLogoLink
                cssClass="fm-entete">
                <div className="fm-entete-offre-bt grid has-gutter flex-center-alt">
                    <div className="fm-entete-offre">
                        {this.renderSeoLine()}
                        {this.renderCashback()}
                        {this.renderEstimatedValidationDate()}
                        {this.renderEbonAvailability()}
                        {this.renderEnterpriseCardCumulative()}
                    </div>
                    {!isEbon && (
                        <div className="fm-entete-bt one-third flex-container-v">
                            {this.renderCTAButton()}
                        </div>
                    )}
                </div>
            </PartnerBlockHorizontalComponent>
        );
    }
}

HeaderComponent.propTypes = {
    id: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    const partner = getPartner(state, ownProps.id);
    const ebonPartner = getEbonPartner(state, Number(ownProps.id));
    const isEbon = ownProps.isEbon;

    return {
        partner,
        ebonPartner,
        i18nPartner: state.i18n.feature.partenaire,
        i18nPage: state.i18n.page.MERCHANTCARD,
        isAuthenticated: state.authentication.isAuthenticated,
        discounts: !isEbon ? toArray(state.discount.discounts[partner.id]) : null,
        ebonSeo: state.ebon.seo
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/HeaderComponent.js